import React from "react";
import { ComponentStory, ComponentMeta } from "@storybook/react";
import { ListingGallery } from "./ListingGallery";
import { ListingResidential } from "../../lib/Listing/mocks";
import { EWsrvTransform } from "../../lib/Media/util";
export default {
  title: "Foundation Web/Listing/Gallery",
  component: ListingGallery,
} as ComponentMeta<typeof ListingGallery>;

const Template: ComponentStory<typeof ListingGallery> = (args) => (
  <ListingGallery {...args} />
);

export const Default3x2 = Template.bind({});
Default3x2.args = {
  listing: ListingResidential,
};
export const Default16x9 = Template.bind({});
Default16x9.args = {
  listing: ListingResidential,
  preset: EWsrvTransform.cover16x9,
  width: 1600,
  height: 900,
};

export const ThumbsLeft3x2 = Template.bind({});
ThumbsLeft3x2.args = {
  listing: ListingResidential,
  imageGalleryProps: { thumbnailPosition: "left" },
};

export const ThumbsRight16x9 = Template.bind({});
ThumbsRight16x9.args = {
  listing: ListingResidential,
  imageGalleryProps: { thumbnailPosition: "right" },
  preset: EWsrvTransform.cover16x9,
  width: 1600,
  height: 900,
};

export const ThumbsRightVitals16x9 = Template.bind({});
ThumbsRightVitals16x9.args = {
  listing: ListingResidential,
  imageGalleryProps: { thumbnailPosition: "right" },
  preset: EWsrvTransform.cover16x9,
  width: 1600,
  height: 900,
  showListingVitals: true,
};

export const HeroWithVitals3x2 = Template.bind({});
HeroWithVitals3x2.args = {
  listing: ListingResidential,
  showThumbs: false,
  showNav: true,
  showFullscreen: false,
  autoPlay: true,
  showCaptions: false,
  showListingVitals: true,
  preset: EWsrvTransform.cover3x2,
  width: 1500,
  height: 1000,
};

export const HeroWithVitals16x9 = Template.bind({});
HeroWithVitals16x9.args = {
  listing: ListingResidential,
  showThumbs: false,
  showNav: true,
  showFullscreen: false,
  autoPlay: true,
  showCaptions: false,
  showListingVitals: true,
  preset: EWsrvTransform.cover16x9,
  width: 1600,
  height: 900,
};
